import React__default from 'react';
import { P as ProgressContainer, C as Container, a as Progress, T as Tick } from './ProgressIndicator.styles-FdMYi9b_.js';
import { T as Text } from '../Text/Text-Ce2yOjWM.js';

const getClampedValue = (val, max) => {
  if (typeof val !== 'number') {
    return 0;
  }
  return Math.min(Math.max(val, 0), max);
};
const defaultLabel = val => /*#__PURE__*/React__default.createElement(Text, {
  color: "default"
}, `${val}%`);
const ProgressIndicator = ({
  max = 100,
  value = 0,
  inline = false,
  size = 'base',
  showLabel = false,
  label = defaultLabel,
  status = 'default',
  targets
}) => {
  var _sortedValueObjects$v, _sortedValueObjects;
  const sortedValueObjects = (Array.isArray(value) ? value : [{
    value
  }]).map(valueObject => ({
    ...valueObject,
    value: getClampedValue(valueObject.value, max)
  })).sort((valueObjectA, valueObjectB) => valueObjectA.value - valueObjectB.value).slice(-3); // only up to 3 values
  const maxValue = (_sortedValueObjects$v = (_sortedValueObjects = sortedValueObjects[sortedValueObjects.length - 1]) === null || _sortedValueObjects === void 0 ? void 0 : _sortedValueObjects.value) !== null && _sortedValueObjects$v !== void 0 ? _sortedValueObjects$v : 0;
  return /*#__PURE__*/React__default.createElement(ProgressContainer, {
    $inline: inline
  }, /*#__PURE__*/React__default.createElement(Container, {
    alignItems: "center"
  }, sortedValueObjects.reverse().map((valueObject, index) => {
    var _valueObject$label;
    return /*#__PURE__*/React__default.createElement(Progress, {
      key: `${valueObject.value}_${(_valueObject$label = valueObject.label) !== null && _valueObject$label !== void 0 ? _valueObject$label : 'key'}`,
      max: max,
      value: valueObject.value,
      $size: size,
      $status: status,
      $colorValue: `${(sortedValueObjects.length - index) * 100}`,
      $radius: index === 0 && sortedValueObjects.length ? 'round' : 'square'
      // <progress> min is always 0
      // aria roles are necessary for component accessibility.
      // Without them, the progress element is treated as indeterminate.
      // aria-role progressbar is already set by the browser and does not need to be set here.
      ,
      "aria-valuemin": 0,
      "aria-valuemax": max,
      "aria-valuenow": valueObject.value,
      "aria-label": valueObject.label
    });
  }), targets && targets.length > 0 && targets.map((targetValue, index) => /*#__PURE__*/React__default.createElement(Tick, {
    key: `${targetValue}_${index + 1}`,
    $size: size,
    $targetValue: targetValue / max * 100,
    $value: maxValue
  }))), showLabel && (label === null || label === void 0 ? void 0 : label(maxValue, max)));
};

export { ProgressIndicator as P };
//# sourceMappingURL=ProgressIndicator-DPLQTKq2.js.map
